import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useHistory } from "react-router-dom";
import api from '../../services/api_exportadores';
import styles from "./styles.module.css";
import apidesp from '../../services/api_despesas';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import Swal from 'sweetalert2';
import { mask, unMask } from 'remask';

export default function Exportadores() {
    const { id } = queryString.parse(useLocation().search);

    const [exportador, setExportador] = useState({});
    const [title, setTitle] = useState('');
    const [filtros, setFiltros] = useState([]);
    const [campos, setCampos] = useState([]);
    const [valores, setValores] = useState([]);

    useEffect(() => {
        api.get(`/id/${id}`).then(function (response) {
            if (response.data) {
                setExportador(response.data);
                if (response.data.filtros) {
                    const groupBy = function (array, key) {
                        return array.reduce((acc, item) => ({
                            ...acc,
                            [item[key]]: [...(acc[item[key]] ?? []), item],
                        }),
                            {})
                    }

                    const grouped = groupBy(response.data.filtros, 'agrupamento')

                    var transformado = Object.keys(grouped).map(function (key) {
                        return [Number(key), grouped[key]];
                    });

                    var filtros = [];

                    transformado.map((r, index) => {
                        r.splice(0, 1);
                        filtros[index] = r[0];
                    })

                    setFiltros(filtros);
                }
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
        });
    }, []);

    useEffect(() => {
        if (exportador && exportador.descricao !== '') {
            setTitle(`EXPORTADOR ${exportador.descricao}`)
        }
    }, [exportador]);

    function renderFiltros(filtro, index) {

        const handleMaskData = function(index, i, value) {
            const originalValue = unMask(value);
            const maskedValue = mask(originalValue, [
                "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
            ]);
            setdesc(index, i, maskedValue);
        }

        function setdesc(index, i, valor) {
            var objfiltros = Object.assign([], filtros);
            objfiltros[index][i].valores_padrao = valor;
            setFiltros(objfiltros)
        }

        if (filtro) {
            return (
                filtro.map((f, i) => {
                    if(f.exp_tipo_campos_id === 2){
                        return (
                            <div>
                                <h4>{(f.required ? f.desc_parametro + '*' : f.desc_parametro)}</h4>
                                <input
                                    type="text"
                                    value={f.valores_padrao}
                                    onChange={(e) => handleMaskData(index, i, e.target.value)}
                                />
                            </div>
                        )
                    } else {
                        return (
                            <div>
                                <h4>{(f.required ? f.desc_parametro + '*' : f.desc_parametro)}</h4>
                                <input
                                    type="text"
                                    value={f.valores_padrao}
                                    onChange={(e) => setdesc(index, i, e.target.value)}
                                />
                            </div>
                        )
                    }
                })
            )
        }
    }

    function renderParametros() {

        return (
            filtros.map((filtro, index) => {
                return (
                    <>
                        <div className={styles.paramsrodar}></div>
                        <div className={styles.groupparams}>
                            <div className={styles.groupparams}>
                                {renderFiltros(filtro, index)}
                            </div>
                            <div>
                                {(filtro[0].tipo_campo ? filtro[0].tipo_campo.informativo : '')}
                                <hr></hr>
                                {(filtro[0].tipo_filtro ? filtro[0].tipo_filtro.informativo : '')}
                            </div>
                        </div>
                        <hr></hr>
                    </>
                )
            })
        )
    }

    function handleView() {

        filtros.map((filtro) => {
            filtro.map((f) => {
                if(f.required && f.valores_padrao === ''){
                    Swal.fire(`O CAMPO ${f.desc_parametro} É OBRIGATÓRIO, PORTANTO NÃO PODE FICAR EM BRANCO!`);
                    return;
                }
            })
        })

        var obj = {};
        obj.sql = exportador.script;
        obj.parametros = filtros;
        setValores([]);
        setCampos([]);
        api.post(`/rodarexportador`, obj).then(function (response) {
            if (response.data && response.data.length > 0) {
                setValores(response.data);
                setCampos(Object.keys(response.data[0]));
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // setGravando(false);
        });

    }

    function renderHeaders() {
        if (campos.length > 0) {
            return (
                campos.map((campo) => {
                    return (
                        <th>{campo}</th>
                    )
                })
            )
        }
    }

    function renderValor(valores) {
        return (
            valores.map((valor) => {
                return (
                    <td>{valor}</td>
                )
            })
        )
    }

    function renderValores(){
        return(
            valores.map((valor) => {
                var valores = Object.values(valor);
                return(
                    <tr>
                        {renderValor(valores)}
                    </tr>
                )
            })
        )
    }

    return (
        <div className="container-lg">
            <Header title={title} />
            <div>
                <hr></hr>
                <h3>PARAMETROS</h3>
                <p>PARÂMETROS SINALIZADOS COM * SÃO OBRIGATÓRIOS</p>
                <p>INFORMAÇÕES ADICIONAIS DE COMO GERAR O RELATÓRIO</p>
                <hr></hr>
                <div>
                    {renderParametros()}
                </div>
                <input type="button" value="VISUALIZAR" onClick={() => handleView()} className="btn btn-primary" />
                <CSVLink
                    data={valores}
                    separator={";"}
                    className="btn-teste btn btn-success"
                >
                    Download
                </CSVLink>
                <table className='table table-sm'>
                    <thead>
                        <tr>
                            {renderHeaders()}
                        </tr>
                    </thead>
                    <tbody>
                        {renderValores()}
                    </tbody>
                </table>
            </div>
        </div>
    )
}